import { useEffect, useRef, useState } from "react";
import "./collections.css";
import Lenis from "@studio-freight/lenis";
import { useTransform, useScroll, motion } from "framer-motion";
import {
  Carousel2,
  Carousel5,
  Banner1,
  Banner2,
  Banner3,
  Banner4,
  ConverseGif7,
  ConverseGif2,
  ConverseGif3,
  ConverseGif5,
  ConverseGif6,
} from "../../../core/assets";
import { MotionValue } from "framer-motion";
import { GridInfo } from "../gridInfo/GridInfo";
import { ShowCase } from "../showcase/ShowCase";
import Zoom from "react-reveal/Zoom";

interface Image {
  image: string; 
}

interface ColumnProps {
  images: Image[];
  y: MotionValue<number>; 
}

const images = [
  { image: ConverseGif6 },
  { image: Banner3 },
  { image: Carousel2 },
  { image: Banner1 },
  { image: ConverseGif7 },
  { image: Carousel5 },
  { image: ConverseGif5 },
  { image: Banner2 },
  { image: ConverseGif3 },
  { image: Banner4 },
  { image: ConverseGif2 },
  { image: Banner2 },
];

export default function Home() {
  const gallery = useRef(null);
  const [dimension, setDimension] = useState({ width: 0, height: 0 });

  const { scrollYProgress } = useScroll({
    target: gallery,
    offset: ["start end", "end start"],
  });
  const { height } = dimension;
  const y = useTransform(scrollYProgress, [0, 1], [0, height * 2]);
  const y2 = useTransform(scrollYProgress, [0, 1], [0, height * 3.3]);
  const y3 = useTransform(scrollYProgress, [0, 1], [0, height * 1.25]);
  const y4 = useTransform(scrollYProgress, [0, 1], [0, height * 3]);

  useEffect(() => {
    const lenis = new Lenis();

    const raf = (time: any) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };

    const resize = () => {
      setDimension({ width: window.innerWidth, height: window.innerHeight });
    };

    window.addEventListener("resize", resize);
    requestAnimationFrame(raf);
    resize();

    return () => {
      window.removeEventListener("resize", resize);
    };
  }, []);

  return (
    <main className="main">
      <div className="spacer h-auto">
        <GridInfo />
      </div>
      <div ref={gallery} className="gallery bg-white ">

    {/* Columns for larger screens */}
    <Column images={[images[0], images[1], images[2]]} y={y} />
    <Column images={[images[3], images[4], images[5]]} y={y2} />
    <Column images={[images[6], images[7], images[8]]} y={y3} />
    <Column images={[images[9], images[10], images[11]]} y={y4} />
  
</div>
      <div className="spacer h-auto ">
        <ShowCase />
      </div>
    </main>
  );
}

const Column: React.FC<ColumnProps> = ({ images, y }) => {
  return (
    <motion.div className="column bg-white " style={{ y }}>
      {images.map((src: any, i: any) => {
        return (
          <div key={i} className="imageContainer ">
            <Zoom bottom cascade>
              <img
                src={src.image}
                alt="collections"
                className="w-[900px] md:h-[600px] h-[100%] object-contain md:object-cover"
               
                //   fill=true
              />
            </Zoom>
          </div>
        );
      })}
    </motion.div>
  );
};
